class ReviewController {
    constructor(ratingService, reviewService, settings) {
        this.ratingService = ratingService;
        this.reviewService = reviewService;
        this.settings = settings;
    }

    $onInit() {
        this.stars = this.data.Rating ? this.ratingService.populateStars(this.data.Rating) : [];
        this.reviewBody = this.reviewService.getHtmlContent(this.data.Body);
        this.source = this.reviewService.getReviewSource(this.reviewSource, this.data.Source);

        this.screenReaderRatingText = `${this.data.Rating} out of ${this.settings.ratingreview.maxRating} stars.`;

        this.screenReaderSummaryText = `Review submitted by ${this.data.Member} on
                                        ${this.data.ScreenReaderCreatedDate}.
                                        ${this.screenReaderRatingText}.
                                        ${this.source}.
                                        ${this.reviewBody}.`;
    }
}

ReviewController.$inject = ['RatingService', 'ReviewService', 'Settings'];

const reviewComponentDefinition = {
    controller: ReviewController,
    template: require('./review.component.html').trim(),
    bindings: {
        data: '<',
        reviewSourceLinks: '<',
        reviewSource: '<',
        isFirstReview: '<',
    },
};

module.exports = {
    ReviewController,
    reviewComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/review/review.component.js